var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeClock"},[_c('span',{staticClass:"hour numFont"},[_vm._v(_vm._s(_vm.hour))]),_c('span',{staticClass:"day numFont"},[_vm._v(_vm._s(_vm.day))]),_c('span',{staticClass:"week"},[_vm._v(_vm._s(_vm.week))])])}
var staticRenderFns = []

export { render, staticRenderFns }